"use client";

import { useEffect, useState, type ComponentType } from "react";

export default function SalifySwiperWrapperGate(props: Record<string, unknown>) {
  const [Inner, setInner] = useState<ComponentType<Record<string, unknown>> | null>(null);

  useEffect(() => {
    let cancelled = false;
    void import("./swiper-client").then((m) => {
      if (!cancelled)
        setInner(() => m.default as unknown as ComponentType<Record<string, unknown>>);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!Inner) {
    return <div style={{ minHeight: 200 }} aria-hidden />;
  }

  return <Inner {...props} />;
}
